import Accordion from "@/components/Accordion";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@velaro/velaro-component-lib";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Header(props: Props) {
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: {
        ...workingStyleConfig,
        ...updates
      }
    });
  };

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="header" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Header</Accordion.Title>
        <Accordion.SubTitle>
          Customize the header section, where the initial interaction begins.
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium">Logo</div>
            <Toggle
              toggled={workingStyleConfig.showLogo}
              changeToggle={() =>
                updateStyleConfig({
                  showLogo: !workingStyleConfig.showLogo
                })
              }
            />
          </div>
          <div className="my-3 border-t border-slate-200" />
          <div className="text-sm font-medium mb-2">Title</div>
          <TextInput
            value={workingLanguageConfig.title}
            setValue={(value) => updateLanguageConfig({ title: value })}
            showEmojiButton={true}
            maxWordCount={60}
          />
          <div className="text-sm font-medium mb-2">Sub Title</div>
          <TextInput
            value={workingLanguageConfig.subtitle}
            setValue={(value) => updateLanguageConfig({ subtitle: value })}
            showEmojiButton={false}
            maxWordCount={60}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
